import { IPurchaseRequisitionTask, PurchaseRequisitionTask } from '../../../types/PurchaseRequisitionTask';
import { PurchaseRequisitionResult } from '../../../../purchase-requisition/types/PurchaseRequisitionResult';
import { DemandDataService } from '../../../../demand/demand-data.service';
import { CommentDataService } from '@lib/comment';
import { ItemClassificationDataService } from '@lib/classification';
import { FileDataService } from '@lib/file';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { IimAutocompleteFilterable } from '@iim-angular/components';
import { I18nService } from '@lib/i18n';

export interface IPurchaseRequisitionApproveWithResultSelectionTask extends IPurchaseRequisitionTask {
    possibleResults: PurchaseRequisitionResult[];
    defaultResult: PurchaseRequisitionResult;
}

export class PurchaseRequisitionResultOption implements IimAutocompleteFilterable<PurchaseRequisitionResultOption> {
    constructor(public readonly type: PurchaseRequisitionResult) {}

    public get value(): PurchaseRequisitionResultOption {
        return this;
    }
    public get valueDisplay(): string {
        switch (this.type) {
            case PurchaseRequisitionResult.RFQ:
                return marker('Anfrage');
            case PurchaseRequisitionResult.QUOTATION:
                return marker('Angebot');
            case PurchaseRequisitionResult.ORDER:
                return marker('Bestellung');
        }
    }

    equals(identifier: string | IimAutocompleteFilterable<PurchaseRequisitionResultOption>): boolean {
        if (identifier instanceof PurchaseRequisitionResultOption) {
            return this.type === identifier.value.type;
        }

        return this.type === identifier;
    }

    matches(searchQuery: string | IimAutocompleteFilterable<PurchaseRequisitionResultOption>): boolean {
        if (searchQuery instanceof PurchaseRequisitionResultOption) {
            return this.equals(searchQuery);
        }

        return this.valueDisplay.includes(searchQuery.toString());
    }
}

export class PurchaseRequisitionApproveWithResultSelectionTask extends PurchaseRequisitionTask {
    possibleResults: PurchaseRequisitionResultOption[];
    defaultResult: PurchaseRequisitionResultOption;

    constructor(
        dto: IPurchaseRequisitionApproveWithResultSelectionTask,
        demandDataService: DemandDataService,
        commentDataService: CommentDataService,
        itemClassificationDataService: ItemClassificationDataService,
        fileDataService: FileDataService,
        i18n: I18nService
    ) {
        super(dto, demandDataService, commentDataService, itemClassificationDataService, fileDataService, i18n);

        this.possibleResults = dto.possibleResults.map(
            (result: PurchaseRequisitionResult) => new PurchaseRequisitionResultOption(result)
        );
        this.defaultResult = new PurchaseRequisitionResultOption(dto.defaultResult);
    }

    public get hasOneSupplierSelected(): boolean {
        return this.purchaseRequisition.demand.suppliers.length === 1;
    }
}
